import React, { useEffect, useRef, useState } from "react";

export default function PixTimer({
  expirationTime,
  qrcode,
  pixExpired,
  setPixExpired,
  theme,
  qrCodeColor,
}) {
  const [timeLeft, setTimeLeft] = useState(expirationTime - Date.now());
  const expirationAlerted = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("expirationTime => ", expirationTime);
      console.log("expiration in date => ", new Date(expirationTime));
      console.log("Date.now() => ", Date.now());
      console.log("Date.now() in date => ", new Date(Date.now()));
      const remainingTime = expirationTime - Date.now();
      console.log("remainingTime => ", remainingTime);
      setTimeLeft(remainingTime);

      if (
        remainingTime <= 0 &&
        (!expirationAlerted.currentTime || expirationAlerted.current !== qrcode)
      ) {
        console.log("pix expired");
        clearInterval(interval);
        handlePixExpired(); // Função para lidar com a expiração do PIX
      }
    }, 1000);

    return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
  }, [expirationTime]);

  const handlePixExpired = () => {
    expirationAlerted.current = qrcode;
    setPixExpired(true);
    // Adicione aqui qualquer ação programática, como redirecionar ou reiniciar o processo.
  };

  // Formata o tempo restante (em milissegundos) para minutos e segundos
  const formatTime = (ms) => {
    const totalSeconds = Math.max(Math.floor(ms / 1000), 0);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  return pixExpired ? (
    <p
      className="text-sm mt-1.5"
      style={{ color: theme?.errorText || "#EF4444" }}
    >
      <b>O pix expirou.</b> Gere um novo pix para realizar o pagamento.
    </p>
  ) : (
    <p
      className="text-[13px] mt-4"
      style={{ color: theme?.mutedText || "#6B7280" }}
    >
      O pix expira em:{" "}
      <span
        id="pix-countdown"
        className="font-medium"
        style={{
          color: theme?.headingText || theme?.secondaryColor || "#FFFFFF",
        }}
      >
        {formatTime(timeLeft)}
      </span>
      .
    </p>
  );
}
